import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IServerSideGetRowsParams } from 'ag-grid-enterprise';
import { forkJoin } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service';
import { GridService } from 'src/app/services/grid.service';
import { UtilityService } from 'src/app/services/utility.service';
import { VendorService } from 'src/app/services/vendor.service';

import { BaseGridComponent } from '../base-grid/base-grid.component';

@Component({
  selector: 'app-vendors-grid',
  // Point the template url to the base grid url
  templateUrl: '../base-grid/base-grid.component.html',
  styleUrls: [
    './vendors-grid.component.less',
    '../base-grid/base-grid.component.less'
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class VendorsGridComponent extends BaseGridComponent implements OnInit {
  constructor(
    protected override GridService: GridService,
    protected override UtilityService: UtilityService,
    protected override AuthService: AuthService,
    private VendorService: VendorService
  ) {
    super(GridService, UtilityService, AuthService);

    this.gridPrimaryKeyFieldName = 'id';
    this.gridType = 'Vendor';
    this.rowModelType = 'serverSide';

    this.ServerSideDataSource = {
      getRows: (params: IServerSideGetRowsParams) => {
        const { request } = params;

        const queryObject = this.constructGridQuery({ request });
        const countQueryObject = this.constructGridQuery(
          { request },
          { isCountQuery: true }
        );

        forkJoin([
          this.VendorService.getVendors(queryObject),
          this.VendorService.getVendorCount(countQueryObject)
        ]).subscribe({
          next: ([Vendors, vendorCount]) => {
            params.success({
              rowData: Vendors,
              rowCount: vendorCount
            });
          },
          error: (error) => {
            console.log(error);
            params.fail();
          }
        });
      }
    };
  }
}
